import React from "react";
import styled from "styled-components";
import { DESKTOPSIZE } from "../../constants";

const Container = styled.div`
  position: relative;
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "auto"};
  max-width: 100%;
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

function StyledImage({ src, alt, width = null, height = null, onClick = null }) {
  let imageWidth = "70%"
  let imageHeight = "20%";
  ;
  if (window.innerWidth > DESKTOPSIZE && width) {
    imageWidth = width;
  }

  return (
    <Container width={imageWidth} height={imageHeight} onClick={onClick}>
      <Image src={src} alt={alt} />
    </Container>
  );
}

export default StyledImage;
